/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{mirrorEasing as r}from"./modifiers/mirror.js";import{reverseEasing as o}from"./modifiers/reverse.js";const i=r=>1-Math.sin(Math.acos(r)),s=o(i),m=r(s);export{i as circIn,m as circInOut,s as circOut};
//# sourceMappingURL=circ.js.map
